import { IEnterpriseObject } from '@cisco-sbg/cspe-mfe-shared-library';
import { TFunction } from 'react-i18next';
import { MSP_CONSTANTS } from './constant';

export const isItManager = (enterpriseType: string): boolean => {
  switch (enterpriseType) {
    case MSP_CONSTANTS.mspManager:
      return true;
    case MSP_CONSTANTS.multiOrgManager:
      return true;
    default:
      return false;
  }
};

export const isItManaged = (enterpriseType: string): boolean => {
  switch (enterpriseType) {
    case MSP_CONSTANTS.mspManaged:
      return true;
    case MSP_CONSTANTS.multiOrgManaged:
      return true;
    default:
      return false;
  }
};

export const isItMsp = (enterpriseType: string): boolean => {
  return isItManager(enterpriseType) || isItManaged(enterpriseType);
};

export const isManagerEnterprise = (enterprise: IEnterpriseObject): boolean => {
  if (!enterprise?.details?.enterpriseType) return false;

  return isItManager(enterprise.details.enterpriseType);
};

export const isManagedEnterprise = (enterprise: IEnterpriseObject): boolean => {
  if (!enterprise?.details?.enterpriseType) return false;

  return isItManaged(enterprise.details.enterpriseType);
};

export const getDeployedRegion = (enterprise: IEnterpriseObject): string => {
  const region = enterprise.details?.region?.label;
  const country = enterprise.details?.country?.label;

  if (country && country !== '') return country;
  if (region && region !== '') return region;
  return '-';
};

export const useTooltipValue = (
  operand: string | number,
  productName: string,
  t: TFunction
): string => {
  const operandNumber =
    typeof operand === 'string' ? parseFloat(operand) : operand;
  if (operandNumber && operandNumber > 1) {
    if (operandNumber === 2) {
      return t('overview:MSPEntitlementsDataTooltip', {
        productName,
        multiplier: t('overview:doubled'),
      });
    } else if (operandNumber === 3) {
      return t('overview:MSPEntitlementsDataTooltip', {
        productName,
        multiplier: t('overview:tripled'),
      });
    } else if (operandNumber > 3) {
      return t('overview:MSPEntitlementsDataTooltip', {
        productName,
        multiplier: t('overview:multipliedByN', { number: operandNumber }),
      });
    }
  }

  return '';
};
